import React from "react";
import { Chip, pxToRem } from "../../platform-style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/sharp-light-svg-icons";

interface ExpandNodeProps {
  title: string;
  chipLabel: number;
}

export const ExpandNode = ({ title, chipLabel }: ExpandNodeProps) => {
  return (
    <div aria-expanded={"false"} style={{ display: "flex", alignItems: "center" }}>
      <FontAwesomeIcon icon={faAngleDown} style={{ marginRight: pxToRem(5) }}></FontAwesomeIcon>
      {title}
      <Chip
        label={chipLabel}
        size={"small"}
        variant={"filled"}
        color={"primary"}
        sx={{
          borderRadius: "50",
          height: pxToRem(18),
          width: pxToRem(18),
          paddingTop: pxToRem(1),
          paddingRight: pxToRem(1),
          marginLeft: pxToRem(5),
          "& .MuiChip-label": { overflow: "visible" },
        }}
      />
    </div>
  );
};
